import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import "./styles/App.css";
import { instance } from "./common";
import KakaoMap from "./KakaoMap";
import LoadService from "./components/ShopDetail/LoadService";
import MainSlide from "./components/ShopDetail/MainSlide";

const ShopDetail = () => {
  const history = useHistory();
  let { id } = useParams();
  const [data, setData] = useState([]);

  useEffect(() => {
    instance.post("/sigong/id", { si_id: id }).then(function (res) {
      // console.log('res is: ', res);
      setData(res.data[0]);
    });
  }, []);

  return (
    <div className="container mb-5">
      <div className="row">
        <div className="col-12 text-center p-0 py-3 active pcTitle">
          대리점 상세보기
        </div>
        <div className="container row">
          <div className="col-6">
            {data.si_img && <MainSlide si_img={data.si_img} />}
          </div>
          <div className="col-6">
            <div>
              <div>
                <span
                  className="font-weight-bold StoreDaeriTitle px-0 d-inline-block w-75"
                  id="sigong-name"
                >
                  {data.si_name}
                </span>
                <span
                  className="btn btn-primary btn-sm p rounded-pill imo_ph_img mt-1 ph_btn"
                  id="telBtn"
                >
                  <LoadService si_tel={data.si_tel} />
                </span>
                <br></br>
              </div>
              <div>
                <span className="detail-name d-block" id="sigong-addr">
                  {" "}
                  주소 : {data.si_address}
                </span>
                <span className="detail-name" id="sigong-tel">
                  연락처 : {data.si_tel}
                </span>
              </div>
              <div className="mt-5">
                <span className="detail-name " id="">
                  실내시공 가능여부 :{" "}
                </span>
                <span className="detail-name " id="">
                  {data.si_possible}
                </span>
              </div>
              <div>
                <span className="detail-name " id="">
                  휴게실 유무 :{" "}
                </span>
                <span className="detail-name " id="">
                  {data.si_rest}
                </span>
              </div>
              <div>
                <span className="detail-name " id="">
                  차량 동시 시공 대수 :{" "}
                </span>
                <span className="detail-name " id="">
                  {data.si_dongsi}
                </span>
              </div>
              <div className="thisIlBtn w-100 mt-5">
                <div className="col-6 p-0">
                  <div
                    className=" thisCustomBtn w-100 mt-3"
                    onClick={() => history.push("/shop")}
                  >
                    뒤로가기
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 mt-3 px-0">
          <div className="text-center ph_map mt-5">
            {/* This component uses DOM... Therefore, si_id={id}*/}
            <KakaoMap si_id={id} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopDetail;
